package com.milta.core.auth

import kotlinx.browser.localStorage
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
class JsDeviceIdProvider : DeviceIdProvider {

    override fun getOrCreateDeviceId(): String =
        localStorage.getItem(KEY_DEVICE_ID) ?: Uuid.random().toString().also {
            localStorage.setItem(KEY_DEVICE_ID, it)
        }

    private companion object {
        const val KEY_DEVICE_ID = "milta_device_id"
    }
}
